import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox, SelectTag } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  IconButton,
  Paper,
  Stack,
  Typography,
  Grid,
  Box,
  TextField as MuiTextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, request, toast } from '../../../../../utils';
import { CustomButtonn } from '../../../../../components';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
const TABLE_COLUMNS = [
  {
    header: 'Icp Diagnosis',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.description}`}
        </span>
      );
    }
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialIcpDiagnosisDataObj = {
  data: [],
  loading: false
};

export const IcpDiagnosisMaster = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [icpDiagnosisDataObj, setIcpDiagnosisDataObj] = useState(initialIcpDiagnosisDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [icpGroupDropdown, setIcpGroupDropdown] = useState([]);
  const [icpSubGroupDropdown, setIcpSubGroupDropdown] = useState([]);
  const { pathname } = useLocation();
  const [input, setInput] = useState('');
  const lastPathSegment = pathname.split('/').pop();

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({ description: Yup.string().required('icpDiagnosis is required') })),
    defaultValues: { description: '', default: false },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('description', selectedRecord.description);
      setValue('icp_version', selectedRecord.icp_version);
      setValue('icp_chapter', selectedRecord.icp_chapter);
      setValue('icp_code', selectedRecord.icp_code);
      setValue('icp_version', selectedRecord.icp_version);
      setValue('icp_group', selectedRecord.icp_group?._id);
      setValue('icp_subgroup', selectedRecord.icp_subgroup?._id);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const getICPGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('icp-group');
    setIcpGroupDropdown(data);
  }, []);

  useEffect(() => {
    getICPGroupDropdown();
  }, [getICPGroupDropdown]);

  const getICPSubGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('icp-subgroup');
    setIcpSubGroupDropdown(data);
  }, []);

  useEffect(() => {
    getICPSubGroupDropdown();
  }, [getICPSubGroupDropdown]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/icp-diagnosis-update' : '/icp-diagnosis-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        icp_version: formValues.icp_version,
        icp_chapter: formValues.icp_chapter,
        icp_code: formValues.icp_code,
        icp_version: formValues.icp_version,
        icp_group: formValues.icp_group,
        icp_subgroup: formValues.icp_subgroup,
        description: formValues.description,
        status: formValues.default ? 'default' : 'active'
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} ICP Diagnosis master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} ICP Diagnosis master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/icp-diagnosis-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled ICP Diagnosis master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled ICP Diagnosis master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/icp-diagnosis-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted ICP Diagnosis master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete ICP Diagnosis master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setIcpDiagnosisDataObj({ loading: true });
    const response = await axios.get(`${BASE_URL}/icp-diagnosis/list?limit=${10}`);
    if (response.data.success) {
      setIcpDiagnosisDataObj({ loading: false, data: response.data?.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIcpDiagnosisDataObj({ loading: false });
    }
  };

  useEffect(() => {
    handleIcpSearch();
  }, [input]);

  const handleIcpSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
   
      try {
        const response = await request('/icp-diagnosis-list', {
          method: 'GET',
          query: { name: lowercasedInput }
        });
        if (response.success && Array.isArray(response.data)) {
          setIcpDiagnosisDataObj({ loading: false, data: response.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setIcpDiagnosisDataObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setIcpDiagnosisDataObj({ loading: false, data: [] });
      }
 
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                ICP Diagnosis Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                  id={`${lastPathSegment}Write`}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, justifyContent: 'space-around' }}
                >
                  <Stack
                    sx={{ border: '0px solid grey', padding: '5px', borderRadius: '5px' }}
                    spacing={0.5}
                    direction="row"
                  >
                    <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICP Version</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="icp_version"
                          placeholder="ICP Version"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICP Chapter</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="icp_chapter"
                          placeholder="ICP Chapter"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICP Code</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="icp_code"
                          placeholder="ICP Code"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICP Group</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          menus={icpGroupDropdown.map((data) => ({ ...data, name: data.icp_group }))}
                          name="icp_group"
                          placeholder="ICP Group"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICP Sub Group</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          menus={icpSubGroupDropdown.map((data) => ({ ...data, name: data.icp_subgroup }))}
                          name="icp_subgroup"
                          placeholder="ICP Sub Group"
                        />
                      </Stack>
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Description</Typography>
                        <TextField
                          name="description"
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          placeholder="Enter Description"
                          fullWidth
                          disabled={!['new', 'edit'].includes(currentAction)}
                        />
                      </Stack>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            ICP Diagnosis Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Diagnosis"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={icpDiagnosisDataObj.data || []}
          loading={icpDiagnosisDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
